import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @title Answer Configuration
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Answers)
@ComponentConfigurationClass("answersConfiguration")
export class AnswersConfiguration {

    /**
     * @description Indicates if the answers disabled by the Progressive Filter are shown greyed-out or completely hidden
     */
    public showDisabled?: boolean;

    /**
     * @description Indicates if answer images should be shown or not
     */
    public showImages?: boolean;

    /**
     * @title Automatically move to the next question
     * @description If enabled, answering a single-selection question automatically forwards the user to the next question
     */
    public automaticForwarding?: boolean;

    /**
     * @title Change the URL
     * @description If enabled, the URL is updated once an answer is given. The URL will open the assistant in its current state
     */
    public preselection?: boolean;

    /**
     * @description If enabled, the assistant will be scrolled to the top of the page after an answer has been selected
     */
    public scrollToTop?: boolean;
}
